// extracted by mini-css-extract-plugin
export default {"fr-view":"ImageContainer_fr-view__sS9V5","container":"ImageContainer_container__B2Aol","wrapper":"ImageContainer_wrapper__MUUhC","image":"ImageContainer_image__hpaTb"};